import { observer } from 'mobx-react-lite';
import { useStore } from '@/hooks/useStore';
// import image, icon
import CircleHelpIcon from '@/assets/icons/circle-help-icon.svg';
import LicenseDriverExample from '@/assets/images/license-driver-example.png';
import { memo, ReactNode, useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { isPathEk } from '@/utils/routes';

const ExampleHelp = observer(() => {
    // hook
    const { pathname } = useLocation();
    const isEk = isPathEk(pathname);

    // store
    const {
        modalStore: { showModal }
    } = useStore();

    // function
    const title = useMemo((): ReactNode => {
        return isEk ?
            (
                <>公的身分証写真のアップロードについて</>
            ) :
            (
                <>免許証写真のアップロードについて</>
            );
    }, [isEk]);

    const content = useMemo((): ReactNode => {
        return isEk ?
            (
                <>
                    公的身分証は横向きで撮影をお願いいたします。
                    <br />
                    公的身分証のアップロードが完了しますと自動で内容を読み取りますので、読み込みの内容にお間違いがないかどうか必ずご確認下さい。
                    <br />
                    また、旧字体などは認識が出来ませんので、必ず手動で修正をお願いいたします。
                </>
            ) :
            (
                <>
                    免許証は横向きで撮影をお願いいたします。
                    <br />
                    免許証のアップロードが完了しますと自動で内容を読み取りますので、読み込みの内容にお間違いがないかどうか必ずご確認下さい。
                    <br />
                    また、旧字体などは認識が出来ませんので、必ず手動で修正をお願いいたします。
                </>
            );
    }, [isEk]);

    const onClickHelpExample = () => {
        showModal({
            id: 'example-help',
            size: 'xl',
            titleClassName: 'hidden',
            content: (
                <div className='flex flex-col gap-4'>
                    <img src={LicenseDriverExample} alt='' className='w-full h-auto' />
                    <div className='text-[1.25rem] font-bold text-center'>
                        {title}
                    </div>
                    <div className='text-center'>
                        {content}
                    </div>
                </div>
            ),
            footerClassName: 'hidden'
        });
    };

    return (
        <div
            onClick={onClickHelpExample}
            className='inline-flex gap-1.5 items-center cursor-pointer hover:underline hover:decoration-1'
        >
            <span className='text-[#666666]'>
                {title}
            </span>
            <img src={CircleHelpIcon} alt='' className='w-[1.125rem] h-[1.125rem]' />
        </div>
    );
});

export default memo(ExampleHelp);
